import * as actionTypes from '@store/actions/actionTypes';

const initialState = {
  airports: [],
  states: [],
  error: null,
  loading: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AIRPORTS_START:
      return {
        ...state,
        error: null,
        loading: true
      };
    case actionTypes.AIRPORTS_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        airports: action.payload.airports,
        states: action.payload.states
      };
    case actionTypes.AIRPORTS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/airports.js